/** The router's default not-found page (1.I-1 deliverable 1). */
import { Link } from '@tanstack/react-router';

export function NotFound(): React.JSX.Element {
  return (
    <main className="cx-shell-state">
      <h1>This page doesn't exist</h1>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </main>
  );
}
